import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft, faAngleRight, faAnglesLeft, faAnglesRight} from "@fortawesome/pro-light-svg-icons";


const Wrapper = styled.div`
  display: flex;
  align-items: center;

  & > * {
    margin-left: 15px;
  }
`

const NumberOfResultsSelect = styled.select`
  background: var(--color-select-pagination-background);
  border: 1px solid var(--color-select-pagination-border);
  width: 48px;
  height: 36px;
`

const PageNumberInput = styled.input`
  height: 36px;
  width: 36px;
  background-color: var(--color-table-pageinput);
  border: 1px solid var(--color-table-border-pageinput);
  border-radius: 8px;
  text-align: center;
`

const ArrowIcon = styled(FontAwesomeIcon)`
  font-size: 1.3rem;
  cursor: ${({$enabled}) => $enabled ? 'pointer' : 'not-allowed'};
  color: ${({$enabled}) => $enabled ? 'var(--color-pagination-arrow-icon-enabled)' : 'var(--color-pagination-arrow-icon)'};
`

export const Pagination = ({tableInstance}) => {
    const {
        pageCount,
        canNextPage,
        canPreviousPage,
        nextPage,
        previousPage,
        setPageSize,
        state,
        gotoPage
    } = tableInstance;
    const {pageSize, pageIndex} = state;

    const goToLastPage = () => gotoPage(pageCount - 1);
    const goToFirstPage = () => gotoPage(0);
    const updatePageSize = (e) => {
        setPageSize(+e.target.value);
    }

    return (
        <Wrapper>
            <span>Show:</span>
            <NumberOfResultsSelect value={pageSize} onChange={updatePageSize}>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
            </NumberOfResultsSelect>
            <ArrowIcon
                icon={faAnglesLeft}
                $enabled={canPreviousPage}
                onClick={canPreviousPage ? goToFirstPage : undefined}
            />
            <ArrowIcon
                icon={faAngleLeft}
                $enabled={canPreviousPage}
                onClick={canPreviousPage ? previousPage : undefined}
            />
            <PageNumberInput type="text" value={pageIndex + 1} onChange={e => {
                const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(pageNumber)
            }}/>
            <ArrowIcon
                icon={faAngleRight}
                $enabled={canNextPage}
                onClick={canNextPage ? nextPage : undefined}
            />
            <ArrowIcon
                icon={faAnglesRight}
                $enabled={canNextPage}
                onClick={canNextPage ? goToLastPage : undefined}
            />
        </Wrapper>
    )
}
